<!-- 奖品记录弹窗 -->
<template>
  <div class="prizes-popup">
    <van-overlay :show="show" @click="show = false" :lock-scroll="false">
      <div class="wrapper" @click.stop>
        <p class="title">我的奖品</p>
        <div class="content">
          <div class="header">
            <span class="text1">参与日期</span>
            <span class="text2">奖品</span>
            <span class="text3">发放状态</span>
          </div>
          <ul class="list" v-if="list.length">
            <li v-for="item in list" :key="item.id">
              <span class="text1">{{ item.lotteryTime }}</span>
              <span class="text2 van-ellipsis">{{ item.prizeName }}</span>
              <span class="text3">{{
                item.status === 1 ? "成功" : "失败"
              }}</span>
            </li>
          </ul>
          <div v-else class="empty-box">
            <img
              src="@/assets/imgs/jiangsuXingyeDigitalCoinLottery/empty.png"
              alt=""
            />
            <p>暂无数据</p>
          </div>
        </div>
        <div class="btn" @click="close">
          <span>知道了</span>
        </div>
      </div>
      <img
        class="close"
        @click="close"
        :src="
          require(`@/assets/imgs/jiangsuXingyeDigitalCoinLottery/close.png`)
        "
        alt=""
      />
    </van-overlay>
  </div>
</template>
<script>
import { Toast } from 'vant'
import { myPrize } from '@/api/cibDCEPLottery.js'
export default {
  components: {},
  props: ['prize', 'isDemo'],
  data() {
    return {
      show: false,
      list: [
        // {
        //   prizeName: '18.88元微信立减金18.88元微信立减金18.88元微信立减金',
        //   lotteryTime: '2024-05-08 13:56:37',
        //   id: 1,
        // },
      ],
    }
  },
  created() {
  },
  methods: {
    myPrize() {
      myPrize({}).then(res => {
        if (res.code === 0) {
          this.list = res.data
        }
      })
    },
    close() {
      this.setShow(false)
    },
    setShow(val) {
      if (val) {
        this.myPrize()
      }
      this.show = val
    },
  },
}
</script>
<style lang="less" scoped>
.prizes-popup {
  position: relative;
  text-align: center;

  .wrapper {
    margin: 20% 20px 20px 20px;
    background: #3f92e3;
    border-radius: 51px;
    border: 11px solid #fffeff;
    text-align: center;
    text-align: center;
    overflow: auto;
    .title {
      padding: 30px 0 10px 0;
      font-weight: bold;
      font-size: 24px;
      color: #000000;
      text-shadow: #ffffff 1px 0 0, #ffffff 0 1px 0, #ffffff -1px 0 0,
        #ffffff 0 -1px 0;
    }

    .btn {
      border: 3px solid #fff;
      border-radius: 30px;
      margin: 20px auto 30px auto;
      width: 160px;
      span {
        display: block;
        line-height: 2.5;
        border-radius: 30px;
        border: 3px solid #000;
        background: #ffffff;
        font-size: 21px;
        font-weight: 600;
        color: #000000;
      }
    }
    .content {
      padding: 10px 20px;
      color: #fff;
      span {
        display: inline-block;
      }
      .text1 {
        width: 37%;
      }
      .text2 {
        width: 37%;
      }
      .text3 {
        width: 25%;
      }
      .header {
        background: #156abd;
        border-radius: 6px;
        font-size: 14px;
        line-height: 3;
      }
      .list {
        padding: 20px 0 0 0;
        height: 200px;
        overflow: auto;
        li {
          padding: 10px 0;
          display: flex;
          align-items: center;
        }
        .text2 {
          line-height: 1;
          font-weight: 600;
        }
      }
    }
  }
  .close {
    width: 35px;
  }
  .empty-box {
    line-height: 3;
    padding: 33px 0 0 0;
    img {
      width: 50px;
    }
  }
}
</style>
